/* WristPop – Vorabladen von Links
   ----------------------------------------------------------------
   Laedt die Zielseite still im Hintergrund, sobald der Nutzer einen
   Link ueberfaehrt (Desktop) oder antippt (Mobil). Beim eigentlichen
   Klick liegt die Seite dann meist schon im Cache und erscheint
   sofort statt nach einer sichtbaren Pause.

   Sicherheitsnetze:
   - nur interne Links derselben Domain
   - keine Warenkorb-/Checkout-/Konto-URLs (dort wuerde ein Vorabruf
     Zustand veraendern oder unnoetig Last erzeugen)
   - jede URL nur einmal
   - aus bei Datensparmodus oder langsamer Verbindung
   - hoechstens 8 Seiten pro Seitenaufruf
*/
(function () {
  'use strict';

  var conn = navigator.connection || {};
  if (conn.saveData) return;
  if (conn.effectiveType && /2g/.test(conn.effectiveType)) return;
  if (!('IntersectionObserver' in window)) return;

  var done = {};
  var count = 0;
  var MAX = 8;
  var SKIP = /\/(cart|checkout|account|challenge|orders|tools)(\/|$|\?)/i;

  function prefetch(url) {
    if (count >= MAX || done[url]) return;
    done[url] = true;
    count++;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function candidate(a) {
    if (!a || !a.href) return null;
    if (a.target && a.target !== '_self') return null;
    if (a.hasAttribute('download')) return null;
    if (a.getAttribute('data-no-prefetch') !== null) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (u.pathname === location.pathname) return null;
    if (SKIP.test(u.pathname)) return null;
    return u.href;
  }

  var timer;
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a');
    var url = candidate(a);
    if (!url) return;
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(url); }, 90);
  }, { passive: true });

  document.addEventListener('mouseout', function () {
    clearTimeout(timer);
  }, { passive: true });

  // Mobil: beim Antippen, also noch vor dem Loslassen
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest && e.target.closest('a');
    var url = candidate(a);
    if (url) prefetch(url);
  }, { passive: true });
})();